
import { getMetricsApiPrefix, metricsFetch } from '../../config/EnvData';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import * as FaIcons from "react-icons/fa";
import React, { useState,useEffect,useRef } from "react";
import axios from 'axios';
import {useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import styled from "styled-components";
import Slider from '@mui/material/Slider';
import AirportCarousel from '../../components/AirportCarousel';
import {roundToNthNearestMinute} from "../../utils/funcs.js"
import {EpochDataBlock} from '../../components/DisplayComponents';
import {PlotLoadingOverlay} from '../../components/PlotLoadingOverlay';
import { display } from '@mui/system';
const DEG_TO_NM   = 60.0405
const NM_TO_DEG   = 1/DEG_TO_NM
const DetailedSummaryOverlayDivStyle = styled.div`
  // position: fixed;
  // text-align:center;
  // justify:center;
  // display:block;
  // flex: none;
  // top:0;
  // bottom:0;
  // left:0;
  // right:0;
  // padding-top:10%;
  // width: 100%;
  // height: 100%;
  // background-color: rgba(0,0,0,0.5); 
  // z-index: 17; 
  // cursor: pointer;
// `;

// const OverlaychartPlotDivStyle = styled.div`
  // display:block;
  // flex:none;
  // justify-content: center;
  // align-items: center;
// `;

// const DetailedSummaryOverlayDiv = ()=>{
        // return(
            // <div style={{position:"fixed",zIndex:15}} >
            // <DetailedSummaryOverlayDivStyle>
                // <OverlaychartPlotDivStyle id="overlayPlot" onClick={handleOverlayClick}>
                // <Plot  data={[{
                    // x: encroachmentData.epochString,
                    // y: encroachmentData.encrDur.Total,
                    // type: 'scatter',
                    // mode: 'lines+markers',
                    // marker: {color: 'red'},
                  // },
                // ]}
                // id="chartPlotDiv"
                // layout={ {title: 'Detailed Summary',width:600,height:400} }
              // />
              // </OverlaychartPlotDivStyle>
            // </DetailedSummaryOverlayDivStyle>
            // </div>
            // );
    // };

const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;

const TitleDiv = styled.div`
    min-width:85vw;
`;
const PlotSectionDiv = styled.div`
    position:relative;
    margin-top: 10px;
    margin-right:10px;
    flex:${(props) => props.flexRatio};
    max-width:100%;
    height:90vh;
    overflow:scroll;
    
    background-color: ${(props) => props.color};
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    &:hover {
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.05) 0px 10px 10px;
    }
`;
const colorPalette = ['#2E91E5','#E15F99','#1CA71C','#FB0D0D','#DA16FF','#222A2A','#B68100','#750D86','#EB663B','#511CFB',
					'#FB0D0D','#DA16FF','#222A2A']
const zoomPlusEvent = new KeyboardEvent('keydown', {
  key: '+',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const axesLineColor ='#FFFF'//'rgba(220,232,247,0.1)'
const axesLineWidth = 5
const calcAvg = array => Math.round((array.reduce((a, b) => a + b) / array.length + Number.EPSILON) * 100) / 100;
const RwyWiseColorNames = ["indianred","mediumslateblue","mediumseagreen","purple","azure"]
const zoomMinusEvent = new KeyboardEvent('keydown', {
  key: '-',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

// <TitleDiv>
            // <h1 style={{marginLeft:'10px'}}>{airport+', '+airportData['city']+' - Mashup Dashboard'}</h1>
        // </TitleDiv>

const homePlotlyIcon = {
            width: 928.6,
            height: 1000,
            path: 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
            transform: 'matrix(1 0 0 -1 0 850)'
        }

const sliderMarks = [
  {
    value: 0,
    label: '5 min',
  },
  {
    value: 1,
    label: '1 hour',
  },
  {
    value: 2,
    label: '24 hours',
  },
];
function getCurrentTime(){

}
const AirGroundInteractions = ({setTitle,pageTitle,backendApiPrefix,metricLookBackHorizonDays}) => {
    const {airport} = useParams()
    const [isChartLoading,setIsChartLoading] = useState(true)
    const [isMapLoading,setIsMapLoading] = useState(true)
    const [lastUpdatedTime,setLastUpdatedTime] = useState(new Date())
    const [airportMapTrace,setAirportMapTrace] = useState({type: "scattermapbox",
                                                           lat: [],
                                                           lon: [],
                                                           text:[],
                                                           textfont:{size:16,color:'black'},
                                                           textposition:'top right',
                                                           marker: {symbol:'marker',color: "black", size: 10,allowoverlap:true},
                                                           hoverinfo:'skip',
                                                           name:'',
                                                           mode:'markers+text',
                                                           hovertemplate:'<extra></extra>',
                                                           showlegend:false})

    const [conflictTracksTrace,setConflictTracksTrace] = useState({type: "scattermapbox",
                                                        lat: [],
                                                        lon: [],
                                                        text: [],
                                                        customdata:[],
                                                        marker: {color: "red", size: 5 },
                                                        opacity:0.3,
                                                        hovertemplate:'<extra></extra><b>Lat</b>:%{lat:.2f} <b>Lon</b>:%{lon:.2f} <b>Alt</b>:%{text:.0f}ft<br>'+
                                                                                    '<b>AC</b>: %{customdata[0]}, <b>Conflict AC</b>: %{customdata[1]}<br>'+
                                                                                    '<b>Conformance Cat.</b>: %{customdata[2]}<br>'+
                                                                                    '<b>Airspace Class</b>: %{customdata[3]}',
                                                        hoverlabel:{bgcolor:'white'},
                                                        showlegend:false})
    
    useEffect(() => {
        setTitle(pageTitle=>'Air-Ground Interactions - '+airport)
    },[airport]);
    // {

    //     name: 'color toggler',
    
    //     icon: icon1,
    
    //     click: function(gd) {
    
    //         var newColor = colors[Math.floor(3 * Math.random())]
    
    //         Plotly.restyle(gd, 'line.color', newColor)
    
    //     }},
    const [airportData, setAirportData] = useState({'location':[],'city':''}); 
    const [queryIterTime,setQueryIterTime] = useState(new Date())
    const [metricStartTime,setMetricStartTime] = useState(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))
    const [selectedEpoch,setSelectedEpoch] = useState('')
    const [latestEpochFlag,setLatestEpochFlag] = useState(true)

    const [epochString,setEpochString] = useState([])
    const [averageLateralMinSeparation,setAverageLateralMinSeparation] = useState([])
    const [maxLateralMinSeparation,setMaxLateralMinSeparation] = useState([])
    const [minLateralMinSeparation,setMinLateralMinSeparation] = useState([])
    const [rwyDurationStats,setRwyDurationStats] = useState([])

    const [lateralMinSeparationRwyWise,setLateralMinSeparationRwyWise] = useState({})
    const [minLateralSeparationEpochRwyWise,setMinLateralSeparationEpochRwyWise] = useState([])
    const [metroplexData,setMetroplexData] = useState({})
    const [mapLayoutLayerData,setMapLayoutLayerData] = useState({})

    const [averageMaxRwyDuration,setAverageMaxRwyDuration] = useState([])
    const [maxMaxRwyDuration,setMaxMaxRwyDuration] = useState([])
    const [minMaxRwyDuration,setMinMaxRwyDuration] = useState([])
    const [maxRwyDurationRwyWise,setMaxRwyDurationRwyWise] = useState([])
    const [maxRwyDurationEpochRwyWise,setMaxRwyDurationEpochRwyWise] = useState([])
    const [approachMarginTrackData,setApproachMarginTrackData] = useState({'ApproachMargins':{}})

    const [displayHorizDistVal,setDisplayHorizDistVal] = useState([])
    const [displayVertDistVal,setDisplayVertDistVal] = useState([])
    const [displayGroundAcData,setDisplayGroundAcData] = useState([''])
    const [displayApproachAcData,setDisplayApproachAcData] = useState([''])
    const [displayRwyData,setDisplayRwyData] = useState([''])
    const [displayCustomData,setDisplayCustomData] = useState([])
    const [displayColorValIds,setDisplayColorValIds] = useState(RwyWiseColorNames[0])
    const [aircraftTrackValues,setAircraftTrackValues] = useState({lat:[],lon:[],alt:[],labelData:[]})

    const [displayRwyStatsX,setDisplayRwyStatsX] = useState([])
    const [displayRwyStatsMedianDur,setDisplayRwyStatsMedianDur] = useState([])
    const [displayRwyStatsMinDurErr,setDisplayRwyStatsMinDurErr] = useState([])
    const [displayRwyStatsMaxDurErr,setDisplayRwyStatsMaxDurErr] = useState([])
    const [displayRwyStatsCustomData,setDisplayRwyStatsCustomData] = useState([])


    const [plotMapLayout, setPlotMapLayout] = useState({
        mapbox: 
        { 
            style: "light", 
            center:{lat:null,lon:null},
            bounds:{'north':null,
                     'east':null,
                    'south':null,
                     'west':null},
            zoom:14,
            accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
            layers:[],
            domain:{'x':[0.01,1],'y':[0.01,0.99]}
        },
        margin:{l:10,t:10,r:12,b:10},
        xaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
        yaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
        showlegend:false,plot_bgcolor:'rgba(220,232,247,0.4)'
        },
        );

    const [plotChartLayout, setPlotChartLayout] = useState({grid:{rows:3,columns:1,ygap:0.2},
            xaxis:{anchor:('y','y2'),
                zeroline:false,
                rangeselector:{
                        buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                            {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                            {count:1,label:'1d',step:'day',stepmode:'backward'},
                            {count:metricLookBackHorizonDays,label:'all',step:'day',stepmode:'backward'}]},
                type:'date',  		
                showticklabels:true,
                autorange:false,
                mirror:'all', showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
        tickfont:{size:10},
        yaxis:{anchor:'x',title:{text:'Min. Lateral<br>Separation [nMi]',size:12},zeroline:false,domain:[0.76,1],range:[],showticklabels:true,autorange:false,
        mirror:'all', showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
        legend:{x:0,xanchor:'left',y:1.02,bgcolor:'rgba(0,0,0,0)',orientation:'h'},
        //xaxis2:{showticklabels:true},
        nticks:8,mirror:'all', showline:true,linecolor:axesLineColor,linewidth:axesLineWidth,
        xaxis2:{zeroline:false,showticklabels:true,autorange:false},
        yaxis2:{title:{text:'Max. Rwy<br>Duration [s]',size:12},zeroline:false,domain:[0.5,0.74],range:[],showticklabels:true,autorange:false,
                mirror:'all', showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
        xaxis3:{title:{text:'Lat. Sep. [nMi]',standoff:15},anchor:'y3',zeroline:false,domain:[0,0.27],range:[0,20],showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
        yaxis3:{title:{text:'Vert Sep. [ft]',standoff:12},anchor:'x3',zeroline:false,domain:[0.05,0.35],range:[0,4000],showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
        xaxis4:{title:{text:'Runway Occupancy Duration',standoff:15},anchor:'y4',zeroline:false,domain:[0.34,0.62],showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
        yaxis4:{title:{text:'Duration [s]',standoff:1},anchor:'x4',zeroline:false,domain:[0.05,0.35],showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
        annotations:[],
        margin:{t:54,r:10,b:20},
        height:640,
        hovermode:'x unified',
        plot_bgcolor:'rgba(220,232,247,0.4)'});

        const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
            'toggleSpikelines','select2d',
            'zoomIn2d','zoomOut2d','lasso2d',
            'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
            'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
            'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
            'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
            'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
            'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
             displaylogo:false,responsive:true})

    // const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
    //     'toggleSpikelines','select2d',
    //     'zoomIn2d','zoomOut2d','lasso2d',
    //     'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
    //     'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
    //     'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
    //     'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
    //     'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
    //     'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
    //      displaylogo:false,responsive:true})

    const [epochRange,setEpochRange] = useState([new Date(),new Date()])
    
    const [leftDivHeight, setLeftDivHeight] = useState(null);
    const [leftDivWidth, setLeftDivWidth] = useState(null);
    
    const [rightDivHeight, setRightDivHeight] = useState(null);
    const [rightDivWidth, setRightDivWidth] = useState(null);
    
    const [revKey, setRevKey] = useState(0);
    
    useEffect(() =>{
      setTimeout(()=>{
      setPlotChartLayout({...plotChartLayout,
                          width:0.98*leftDivWidth
                        });
      
      // setPlotMapLayout({...plotMapLayout,
                       // width:0.98*rightDivWidth,
                       // });
                       
      setPlotMapLayout({...plotMapLayout,
                           width:0.98*rightDivWidth,
                           mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+1*NM_TO_DEG,
                                                     'east':airportData['location'][1]+1*NM_TO_DEG,
                                                    'south':airportData['location'][0]-1*NM_TO_DEG,
                                                     'west':airportData['location'][1]-1*NM_TO_DEG},
                                    },
                            zoom:7});
                                    
      setAirportMapTrace({...airportMapTrace,
                        lat: [airportData['location'][0]],
                        lon: [airportData['location'][1]],
                        text:[airport],
                        name:airport,
                        hovertemplate:'<extra></extra>'+airport,
                        })
                       
      },20)
    },[leftDivWidth,rightDivWidth,airportData]);
    

    useEffect(()=>{
        // var approachMarginData_api_latest = "https://chapfk2u97.execute-api.us-east-2.amazonaws.com/test/approach-margins?airport="+
        //                 airport+"&duration=latest"
        // var approachMarginTrackData_api = "https://chapfk2u97.execute-api.us-east-2.amazonaws.com/test/approach-margins/approach-margin-tracks?airport="+
        //                 airport
        var metroplexData_api_prefix = getMetricsApiPrefix() + 'metroplex-airspace?airport='
        var mapLayerApi_prefix = getMetricsApiPrefix() + 'airport-surface-layout/map-layer-data?airport='
        Promise.all([
            metricsFetch(metroplexData_api_prefix+airport),
            metricsFetch(mapLayerApi_prefix+airport),
        ]).then(function (responses) {
            // Get a JSON object from each of the responses
            return Promise.all(responses.map(function (response) {
                return response.json();
            }));
        }).then(function (json_data_array) {
            setMetroplexData(json_data_array[0])
            setMapLayoutLayerData(json_data_array[1])
            var mapCenter = json_data_array[0]['mapCenter']
            console.log(mapCenter)
            setPlotMapLayout({...plotMapLayout,
                                mapbox:{...plotMapLayout.mapbox,
                                    center:{lat:mapCenter[0]+0.002,lon:mapCenter[1]},
                                    bounds:{'north':mapCenter[0]+1*NM_TO_DEG,
                                        'east':mapCenter[1]+1*NM_TO_DEG,
                                        'south':mapCenter[0]-1*NM_TO_DEG,
                                        'west':mapCenter[1]-1*NM_TO_DEG},
                                    layers:json_data_array[1]
                                }
            })
        }).catch(function (error) {
            // if there's an error, log it
            console.log(error);
        });
    },[airport]);             

    useEffect(() => {
        axios.post(backendApiPrefix+'/api/get-airport-data/',{airport:airport})
            .then(response => {
                var jsonData = response.data.message
                console.log(jsonData)
                setAirportData(jsonData)
             })
            .catch(error => {
                console.log(error);
            });
        setConflictTracksTrace({...conflictTracksTrace,
                lat:[],lon:[],text:[],customdata:[]})
    },[airport]);
    
    
    useEffect(() => {        
        const QUERY_CHUNK_HOURS = 12;
        if(queryIterTime.getTime() >= metricStartTime.getTime()){
            var queryEndTime = queryIterTime
            var shiftedQueryIterTime = new Date(queryIterTime.getTime() - QUERY_CHUNK_HOURS* 60*60*1000)
            var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
            var queryEndTimeForAPIQuery = queryEndTimeComps[3]+queryEndTimeComps[2]+queryEndTimeComps[1]+queryEndTimeComps[4]+queryEndTimeComps[5]

            var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
            var queryStartTimeForAPIQuery = queryStartTimeComps[3]+queryStartTimeComps[2]+queryStartTimeComps[1]+queryStartTimeComps[4]+queryStartTimeComps[5]
            
            axios.post(backendApiPrefix+'/api/get-air-ground-interactions-data/',
                            {airport:airport,from:queryStartTimeForAPIQuery,to:queryEndTimeForAPIQuery})
                .then(response => {
                    var jsonData = response.data.message
                    setQueryIterTime(shiftedQueryIterTime)
                    // if(jsonData.epochString=== epochString[epochString.length-1]){
                    //     return; 
                    // }
                    console.log(jsonData.epochString.length)
                    console.log(jsonData.rwyDurationStats.length)
                    console.log(jsonData.epochString.length===jsonData.rwyDurationStats.length?"LENGTHS MATCH":"NO MATCH")
                    setEpochString([...jsonData.epochString,...epochString])
                    if(latestEpochFlag&&selectedEpoch===''){
                        var pIndex; 
                        var medianDur = []; var minDurErr = []; var maxDurErr = [];
                        var additionalData = []
                        if(epochString.length>0){
                            setSelectedEpoch(epochString[epochString.length-1])
                            pIndex = rwyDurationStats.length-1
                            setDisplayRwyStatsX(Object.keys(rwyDurationStats[pIndex]))
                            for(var rwy of Object.keys(rwyDurationStats[pIndex])){
                                medianDur.push(rwyDurationStats[pIndex][rwy].median)
                                minDurErr.push(rwyDurationStats[pIndex][rwy].minErr)
                                maxDurErr.push(rwyDurationStats[pIndex][rwy].maxErr)
                                additionalData.push([rwyDurationStats[pIndex][rwy].median,
                                                    rwyDurationStats[pIndex][rwy].min,
                                                    rwyDurationStats[pIndex][rwy].max,
                                                    rwyDurationStats[pIndex][rwy].mean,
                                                    rwyDurationStats[pIndex][rwy].perc95th])
                            };
                            setDisplayRwyStatsMedianDur(medianDur);
                            setDisplayRwyStatsMaxDurErr(maxDurErr);
                            setDisplayRwyStatsMinDurErr(minDurErr);
                            setDisplayRwyStatsCustomData(additionalData);
                        }else{
                            setSelectedEpoch(jsonData.epochString[jsonData.epochString.length-1])
                            pIndex = jsonData.rwyDurationStats.length-1
                            setDisplayRwyStatsX(Object.keys(jsonData.rwyDurationStats[pIndex]))
                            for(var rwy of Object.keys(jsonData.rwyDurationStats[pIndex])){
                                medianDur.push(jsonData.rwyDurationStats[pIndex][rwy].median)
                                minDurErr.push(jsonData.rwyDurationStats[pIndex][rwy].minErr)
                                maxDurErr.push(jsonData.rwyDurationStats[pIndex][rwy].maxErr)
                                additionalData.push([jsonData.rwyDurationStats[pIndex][rwy].median,
                                                   jsonData.rwyDurationStats[pIndex][rwy].min,
                                                   jsonData.rwyDurationStats[pIndex][rwy].max,
                                                   jsonData.rwyDurationStats[pIndex][rwy].mean,
                                                   jsonData.rwyDurationStats[pIndex][rwy].perc95th])
                            };
                            setDisplayRwyStatsMedianDur(medianDur);
                            setDisplayRwyStatsMaxDurErr(maxDurErr);
                            setDisplayRwyStatsMinDurErr(minDurErr);
                            setDisplayRwyStatsCustomData(additionalData);
                        }
                    }
                    
                    // if(latestEpochFlag){
                    //     setSelectedPointIndex(selectedPointIndex+1)
                    //     setSelectedEpoch(jsonData.epochString)
                    // }
                    if(JSON.stringify(lateralMinSeparationRwyWise)==='{}'){
                        setLateralMinSeparationRwyWise(jsonData.lateralMinSeparationRwyWise)
                    }
                    else{
                        for(var rwy of Object.keys(jsonData.lateralMinSeparationRwyWise)){
                            setLateralMinSeparationRwyWise({...lateralMinSeparationRwyWise,
                                                            rwy:[...jsonData.lateralMinSeparationRwyWise[rwy],
                                                                 ...(Object.hasOwn(lateralMinSeparationRwyWise,rwy)?lateralMinSeparationRwyWise[rwy]:[])]})
                        }
                    }
                    setAverageLateralMinSeparation([...jsonData.averageLateralMinSeparation,...averageLateralMinSeparation])
                    setMinLateralMinSeparation([...jsonData.minLateralMinSeparation,...minLateralMinSeparation])
                    setMaxLateralMinSeparation([...jsonData.maxLateralMinSeparation,...maxLateralMinSeparation])
                    setAverageMaxRwyDuration([...jsonData.averageMaxRwyDuration,...averageMaxRwyDuration])
                    setMinMaxRwyDuration([...jsonData.minMaxRwyDuration,...minMaxRwyDuration])
                    setMaxMaxRwyDuration([...jsonData.maxMaxRwyDuration,...maxMaxRwyDuration])
                    
                    setRwyDurationStats([...jsonData.rwyDurationStats,...rwyDurationStats])
                    
                    
                    // handleLatestEpochButton()
                    var yRangeMax; var y2RangeMax;
                    var xRangeMin; var xRangeMax;
                    if(averageLateralMinSeparation.length>0){
                        yRangeMax = 1.2*(Math.max(...[...maxLateralMinSeparation,...jsonData.maxLateralMinSeparation])+
                                         Math.max(...[...averageLateralMinSeparation,...jsonData.averageLateralMinSeparation]))
                        y2RangeMax = 1.5*Math.max(...[...maxMaxRwyDuration,...jsonData.maxMaxRwyDuration])
                        xRangeMin = epochString[0]
                        xRangeMax = epochString[epochString.length-1]
                        setEpochRange([xRangeMin,xRangeMax])
                    }else{
                        yRangeMax = 1.2*(Math.max(...jsonData.maxLateralMinSeparation)+
                                         Math.max(...jsonData.averageLateralMinSeparation))
                        y2RangeMax = 1.5*Math.max(...jsonData.maxMaxRwyDuration)
                        xRangeMin = jsonData.epochString[0]
                        xRangeMax = jsonData.epochString[jsonData.epochString.length-1]
                        setEpochRange([xRangeMin,xRangeMax])
                    }
                    
                    setPlotChartLayout({...plotChartLayout,
                        xaxis:{...plotChartLayout.xaxis,
                                range:[xRangeMin,xRangeMax]
                        },
                        yaxis:{...plotChartLayout.yaxis,
                                 range:[0,yRangeMax]
                        },
                        yaxis2:{...plotChartLayout.yaxis2,
                                    range:[0,y2RangeMax]
                        },uirevision:1,width:0.98*leftDivWidth})
                    setIsChartLoading(false)
            })
                    .catch(error => {
                    console.log(error);
                    setIsChartLoading(false)
                    });
        // }
        }else{
            fetchApproachMarginTrackData(epochString[epochString.length-1])
        }

    },[queryIterTime])   
    
    useEffect(() =>{
        setPlotChartLayout({...plotChartLayout,
            yaxis:{...plotChartLayout.yaxis,
                     range:[0,1.2*Math.max(...averageLateralMinSeparation)]
            },
            yaxis2:{...plotChartLayout.yaxis2,
                        range:[0,1.5*Math.max(...maxMaxRwyDuration)]
            }})
    },[])
    useEffect(() => {
                setPlotMapLayout({...plotMapLayout,
                                    mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+1*NM_TO_DEG,
                                                     'east':airportData['location'][1]+1*NM_TO_DEG,
                                                    'south':airportData['location'][0]-1*NM_TO_DEG,
                                                     'west':airportData['location'][1]-1*NM_TO_DEG},
                                    zoom:7}});
                                    
        setAirportMapTrace({...airportMapTrace,
                            lat: [airportData['location'][0]],
                            lon: [airportData['location'][1]],
                            text:[airport],
                            name:airport,
                            hovertemplate:'<extra></extra>'+airport,
                            })
    },[airportData])
    
    
    // const mounted = useRef();
    // useEffect(() => {
    //    if(mounted.current){
    //        // Component mounted
    //     //    console.log("Updated")
    //    } else {
    //         console.log("Mounted")
    //         mounted.current = true
            
    //    }
    // });
    // const chartDiv = useCallback(node => {
        // if (node !== null) {
          // setLeftDivHeight(node.getBoundingClientRect().height);
          // setLeftDivWidth(node.getBoundingClientRect().width);
          // console.log("HEIGHT",height)
          // console.log("HEIGHT",width)
        // }
        // }, []);
    const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // This will be called on both refresh and page close
      setIsRefreshing(true);
      setRevKey(prevVal => prevVal +1)
      // The following is necessary for older browsers
      event.preventDefault();
      event.returnValue = '';
    };

    
    window.addEventListener('load', handleBeforeUnload);

    return () => {
      window.removeEventListener('load', handleBeforeUnload);
    };
  });

  useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setLeftDivWidth(event[0].contentBoxSize[0].inlineSize);
            setLeftDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyChartDiv"));
        
        
    });
    
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
            setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyMapDiv"));
    });
    const [menuOption, setMenuOption] = React.useState(1);

    const handleChange = (event: SelectChangeEvent) => {
        setMenuOption(String(event.target.value));
      };
    
    useEffect(() => {
        const interval = setInterval(() => {
          setLastUpdatedTime(new Date())
          getLatestMetricData()
        }, 10000);
        return () => clearInterval(interval);
      }, [latestEpochFlag,epochString,airportData]);
  
    const handleLatestEpochButton = () =>{
        var pIndex = epochString.length-1
        console.log("PIDX",pIndex)
        console.log(rwyDurationStats)
        setSelectedEpoch(epochString[pIndex])
        setLatestEpochFlag(true)
        setPlotChartLayout({...plotChartLayout,
                               yaxis:{...plotChartLayout.yaxis,
                                        range:[0,1.2*(Math.max(...averageLateralMinSeparation)+Math.max(...maxLateralMinSeparation))]
                               },
                               yaxis2:{...plotChartLayout.yaxis2,
                                range:[0,1.5*Math.max(...maxMaxRwyDuration)]
                       }})
        fetchApproachMarginTrackData(epochString[pIndex])
        setDisplayRwyStatsX(Object.keys(rwyDurationStats[pIndex]))
        var medianDur = []; var minDurErr = []; var maxDurErr = [];
        var additionalData = []
        for(rwy of Object.keys(rwyDurationStats[pIndex])){
            medianDur.push(rwyDurationStats[pIndex][rwy].median)
            minDurErr.push(rwyDurationStats[pIndex][rwy].minErr)
            maxDurErr.push(rwyDurationStats[pIndex][rwy].maxErr)
            additionalData.push([rwyDurationStats[pIndex][rwy].median,
                                 rwyDurationStats[pIndex][rwy].min,
                                 rwyDurationStats[pIndex][rwy].max,
                                 rwyDurationStats[pIndex][rwy].mean,
                                 rwyDurationStats[pIndex][rwy].perc95th])
        };
        setDisplayRwyStatsMedianDur(medianDur);
        setDisplayRwyStatsMaxDurErr(maxDurErr);
        setDisplayRwyStatsMinDurErr(minDurErr);
        setDisplayRwyStatsCustomData(additionalData);
    };
    
    const handleDoubleClickOnMap=(data)=>{
        
        setPlotMapLayout({...plotMapLayout,
            mapbox: {...plotMapLayout.mapbox,
                        center:{
                        lat:airportData['location'][0],
                        lon:airportData['location'][1]
                        },
                        bounds:{'north':airportData['location'][0]+1*NM_TO_DEG,
                             'east':airportData['location'][1]+1*NM_TO_DEG,
                            'south':airportData['location'][0]-1*NM_TO_DEG,
                             'west':airportData['location'][1]-1*NM_TO_DEG},
            zoom:7}});
    }
    function getLatestMetricData(){
        axios.post(backendApiPrefix+'/api/get-air-ground-interactions-data/latest/',{airport:airport})
          .then(response => {
            var jsonData = response.data.message
            if(jsonData.epochString=== epochString[epochString.length-1]){
                return; 
            }
            setEpochString([...epochString,jsonData.epochString])
            if(latestEpochFlag){
                setSelectedEpoch(jsonData.epochString)
            }
            // for(var rwy of Object.keys(lateralMinSeparationRwyWise)){
            //     setLateralMinSeparationRwyWise({...lateralMinSeparationRwyWise,
            //                                     rwy:[...lateralMinSeparationRwyWise[rwy],jsonData.lateralMinSeparationRwyWise[rwy]]})
            // }
            // setLateralMinSeparationRwyWise([...lateralMinSeparationRwyWise,jsonData.lateralMinSeparationRwyWise])
            setAverageLateralMinSeparation([...averageLateralMinSeparation,jsonData.averageLateralMinSeparation])
            setMinLateralMinSeparation([...minLateralMinSeparation,jsonData.minLateralMinSeparation])
            setMaxLateralMinSeparation([...maxLateralMinSeparation,jsonData.maxLateralMinSeparation])
            setAverageMaxRwyDuration([...averageMaxRwyDuration,jsonData.averageMaxRwyDuration])
            setMinMaxRwyDuration([...minMaxRwyDuration,jsonData.minMaxRwyDuration])
            setMaxMaxRwyDuration([...maxMaxRwyDuration,jsonData.maxMaxRwyDuration])
            
            if(rwyDurationStats.length>0){
                setRwyDurationStats([...rwyDurationStats,jsonData.rwyDurationStats])
            }else{
                setRwyDurationStats([jsonData.rwyDurationStats])
            }
            
            // setPlotChartLayout({...plotChartLayout,
            //     yaxis:{...plotChartLayout.yaxis,
            //              range:[0,1.2*Math.max(...jsonData.averageLateralMinSeparation)]
            //     },
            //     yaxis2:{...plotChartLayout.yaxis2,
            //                 range:[0,1.5*Math.max(...jsonData.maxMaxRwyDuration)]
            //     }})
    })         
          .catch(error => {
            console.log(error);
          });
        
    }
    function updateEpochWiseDetailedData(approachMarginTrackData){
        var additionalData = []
        var colorValIds=[]; 
        
        var groundAcDataVal = []; var approachAcDataVal = []; var rwyDataVal=[]
        var rwyIdx = 0; 

        var hDistVal = []; var vDistVal = [];
        if(approachMarginTrackData.ApproachMargins){
            
            for(var rwy of Object.keys(approachMarginTrackData.ApproachMargins)){
                for(var ac1 of Object.keys(approachMarginTrackData.ApproachMargins[rwy])){
                    for(var ac2 of Object.keys(approachMarginTrackData.ApproachMargins[rwy][ac1])){
                        var hDist = approachMarginTrackData.ApproachMargins[rwy][ac1][ac2]['horiz_dist']
                        var vDist = approachMarginTrackData.ApproachMargins[rwy][ac1][ac2]['vert_dist']
                        hDistVal.push(...hDist)
                        vDistVal.push(...vDist)

                        additionalData.push(...Array(hDist.length).fill([rwy,ac1,ac2]))
                        colorValIds.push(...Array(hDist.length).fill(rwyIdx))
                        groundAcDataVal.push([ac1])
                        approachAcDataVal.push([ac2])
                        rwyDataVal.push([rwy])
                    }
                }
                rwyIdx = rwyIdx + 1
            }
        }
        
        setDisplayHorizDistVal(hDistVal)
        setDisplayVertDistVal(vDistVal)

        setDisplayGroundAcData(groundAcDataVal)
        setDisplayApproachAcData(approachAcDataVal)
        setDisplayRwyData(rwyDataVal)
        setDisplayCustomData(additionalData)
        setDisplayColorValIds(colorValIds)

        var acLat = []; var acLon = []; var acAlt = [];var acPosTime = []; var acid=[]
        var additionalDataSurfaceTracks = []

        for(var ac of Object.keys(approachMarginTrackData.AcInfo||{})){
            var latVal = approachMarginTrackData.AcInfo[ac]['latitude']
            acLat.push(...latVal)
            acLon.push(...approachMarginTrackData.AcInfo[ac]['longitude'])
            acAlt.push(...approachMarginTrackData.AcInfo[ac]['altitude'])
            acPosTime.push(...approachMarginTrackData.AcInfo[ac]['posTime'])
            for(var idx in approachMarginTrackData.AcInfo[ac]['posTime']){
                additionalDataSurfaceTracks.push([approachMarginTrackData.AcInfo[ac]['posTime'][idx],
                                                  ac])
            }
        }
        
        setAircraftTrackValues({...aircraftTrackValues,
                                    lat:acLat,
                                    lon:acLon,
                                    alt:acAlt,
                                    labelData:additionalDataSurfaceTracks})
        
        
        
        // var colorData = RwyWiseColorNames[0]
        // if(rwyIdx >1){
        //     var colorData = [displayColorValIds]
        // }
        // Plotly.update(plotDiv,{'x':[displayHorizDistVal],'y':[displayVertDistVal],'text':[displayColorValIds],'marker.colorscale':RwyWiseColorNames,
        //                        'marker.color':colorData,
        //                        'customdata':[additionalData]},{},[4])
                               
        // Plotly.update(plotDiv,{'header':{'values':[["<b>Ground AC</b>"],['<b>Approach AC</b>'],['<b>Rwy</b>']],
        //                                         align: "center",
        //                                         line: {width: 1, color: 'black'},
        //                                         fill: {color: "lightgrey"},
        //                                         font: {family: "Arial", size: 14, color: "black"}},
        //                         'cells':{
        //                                 values: [groundAcData,approachAcData,rwyData],
        //                                 align: "center",
        //                                 height:30,
        //                                 line: {color: "black", width: 1},
        //                                 font: {family: "Arial", size: 14, color: ["black"]}
        //                                 },
        //                             },[6])
    };

    function fetchApproachMarginTrackData(selectedEpoch){
        var epochStringComps = selectedEpoch.split(/-| |:/) 
        var epochFormatForAPIQuery = epochStringComps[0]+'-'+epochStringComps[1]+'-'+epochStringComps[2]+'T'+
                                     epochStringComps[3]+':'+epochStringComps[4]+':00'
            
        var approachMarginTrackData_api_epoch = getMetricsApiPrefix() + 'approach-margins/approach-margin-tracks?airport='+
                                                            airport+'&epoch='+epochFormatForAPIQuery

        Promise.all([
                metricsFetch(approachMarginTrackData_api_epoch)
            ]).then(function (responses) {
                // Get a JSON object from each of the responses
                return Promise.all(responses.map(function (response) {
                    return response.json();
                }));
            }).then(function (json_data_array) {
                var trackData = json_data_array[0] || {}
                // Normalize so the render path (which reads .ApproachMargins) never
                // sees an undefined key and throws Object.keys(undefined) -> blank page.
                if(!trackData.ApproachMargins){ trackData.ApproachMargins = {} }
                if(!trackData.AcInfo){ trackData.AcInfo = {} }
                setApproachMarginTrackData(trackData)
                updateEpochWiseDetailedData(trackData)
                setIsMapLoading(false)
            }).catch(function (error) {
                // if there's an error, log it
                console.log(error);
                setIsMapLoading(false)
            });
    }

    const handleClickOnChart=(data)=>{
        var point = data.points[0]
        
        if(!(new Date(point.x) instanceof Date && !isNaN(new Date(point.x).valueOf()))){
            return;
        }
        console.log(point)
        console.log(point.pointIndex)
        console.log(epochString[point.pointIndex])
        setSelectedEpoch(epochString[point.pointIndex])
        setLatestEpochFlag(false)
        var yRangeMax; var y2RangeMax;
        var xRangeMin; var xRangeMax;
        
        yRangeMax = 1.2*(Math.max(...maxLateralMinSeparation)+Math.max(...averageLateralMinSeparation))
        y2RangeMax = 1.5*Math.max(...maxMaxRwyDuration)
                
        setPlotChartLayout({...plotChartLayout,
            yaxis:{...plotChartLayout.yaxis,
                     range:[0,yRangeMax]
            },
            yaxis2:{...plotChartLayout.yaxis2,
                        range:[0,y2RangeMax]
            },uirevision:1,width:0.98*leftDivWidth})
        
        
        fetchApproachMarginTrackData(epochString[point.pointIndex])
        console.log(rwyDurationStats)
        setDisplayRwyStatsX(Object.keys(rwyDurationStats[point.pointIndex]))
        var medianDur = []; var minDurErr = []; var maxDurErr = [];
        var additionalData = []
        if(rwyDurationStats.length > 0){
            for(rwy of Object.keys(rwyDurationStats[point.pointIndex])){
                medianDur.push(rwyDurationStats[point.pointIndex][rwy].median)
                minDurErr.push(rwyDurationStats[point.pointIndex][rwy].minErr)
                maxDurErr.push(rwyDurationStats[point.pointIndex][rwy].maxErr)
                additionalData.push([rwyDurationStats[point.pointIndex][rwy].median,
                                     rwyDurationStats[point.pointIndex][rwy].min,
                                     rwyDurationStats[point.pointIndex][rwy].max,
                                     rwyDurationStats[point.pointIndex][rwy].mean,
                                     rwyDurationStats[point.pointIndex][rwy].perc95th])
            };
        }
        
        console.log(medianDur)
        setDisplayRwyStatsMedianDur(medianDur);
        setDisplayRwyStatsMaxDurErr(maxDurErr);
        setDisplayRwyStatsMinDurErr(minDurErr);
        setDisplayRwyStatsCustomData(additionalData);
    };



    var avgLateralSeparation_trace = {  x:epochString,y:averageLateralMinSeparation,
                                        error_y: {type: 'data',
                                        symmetric: false,
                                        array: maxLateralMinSeparation,
                                        arrayminus: minLateralMinSeparation},
                                        type:'scatter',
                                        name:'Mean Separation Range',
                                        xaxis:'x',
                                        yaxis:'y',
                                        showlegend:false}
    // var minLateralSeparationRwyWise_traceList = []
    // for (var rwy of Object.keys(lateralMinSeparationRwyWise)) {
    //     minLateralSeparationRwyWise_traceList.push({x:minLateralSeparationEpochRwyWise[rwy],
    //                         y:lateralMinSeparationRwyWise[rwy],
    //                         type: 'scatter',
    //                         name:" Mean Lat. Sep. ("+rwy+")",
    //                         hovertemplate:'<extra></extra>'+rwy+' Lateral Separation:%{y}',
    //                         xaxis:'x',
    //                         yaxis:'y',
    //                         visible:'legendonly'})
    // }
    var maxRwyDurationRange_trace = {x:epochString,
                                        y:averageMaxRwyDuration,
                                        error_y: {type: 'data',
                                                symmetric: false,
                                                array: maxMaxRwyDuration,
                                                arrayminus: minMaxRwyDuration},
                                        type:'scatter',
                                        name:'Max. Duration Range',
                                        xaxis:'x',
                                        yaxis:'y2',
                                        showlegend:false};
                    
    var maxRwyDurationRwyWise_traceList = []
    for (var rwy of Object.keys(maxRwyDurationRwyWise)) {
        maxRwyDurationRwyWise_traceList.push({x:maxRwyDurationEpochRwyWise[rwy],
                            y:maxRwyDurationRwyWise[rwy],
                            type: 'scatter',
                            name:"Max Rwy Dur. ("+rwy+")",
                            hovertemplate:'<extra></extra>'+rwy+' Max Duration:%{y}',
                            xaxis:'x',
                            yaxis:'y2',
                            visible:'legendonly'})
    }
    
        
    var separationDist_trace = {x:displayHorizDistVal,y:displayVertDistVal,text:displayColorValIds,
                                type:'scatter',
                                xaxis:'x3',yaxis:'y3',
                                customdata:displayCustomData,
                                mode:'markers',
                                marker:{colorscale:RwyWiseColorNames,
                                        color:Object.keys(approachMarginTrackData.ApproachMargins||{}).length>1?[displayColorValIds]:RwyWiseColorNames[0]},
                                showlegend:false,
                                hovertemplate:'<extra></extra><b>Horiz. Dist</b>:%{x:.2f} nMi <b>Vert Dist.</b>:%{y} ft <br>'+
                                                '<b>Rwy</b>:%{customdata[0]}<br>'+
                                                '<b>Ground AC</b>: %{customdata[1]}, <b>Approach AC</b>: %{customdata[2]}<br>'}
    
    var rwyDuration_trace = {x:displayRwyStatsX,
                             y:displayRwyStatsMedianDur,
                                error_y:{
                                    type: 'data',
                                    array:displayRwyStatsMaxDurErr,arrayminus:displayRwyStatsMinDurErr,
                                    visible: true},
                            type:'bar',
                            mode:'markers',
                            xaxis:'x4',yaxis:'y4',
                            customdata:displayRwyStatsCustomData,
                            showlegend:false,
                            hovertemplate:'<extra></extra>Epoch: '+selectedEpoch+
                                            '<br>Median Dur: %{y}'+
                                            '<br>Min. Dur: %{customdata[0]}'+
                                            '<br>Max. Dur: %{customdata[1]}'+
                                            '<br>Mean Dur: %{customdata[2]}'+
                                            '<br>95th Perc Dur: %{customdata[3]}'}
    var acDataTableTrace = {
                type: 'table',
                header: {
                    values: [['<b> Ground AC</b>'],['<b> Approach AC</b>'],['<b>Rwy</b>']],
                    align: "center",
                    line: {width: 1, color: 'black'},
                    fill: {color: "lightgrey"},
                    font: {family: "Arial", size: 12, color: "black"}},
                cells: {
                    values: [displayGroundAcData,displayApproachAcData,displayRwyData],
                    align: "center",
                    line: {color: "black", width: 1},
                    fill: {color: "white"},
                    height:30,
                    font: {family: "Arial", size: 12, color: ["black"]}
                },
                columnwidth:[0.4,0.4,0.2],
                visible:true,
                domain:{'x':[0.64,1],'y':[0,0.35]}}
                
    // var clickMarkerLatSeparation = {x:[],y:[],
    //             type:'scatter',
    //             xaxis:'x',yaxis:'y',
    //             mode:'lines',
    //             showlegend:false,
    //             hoverinfo:'skip',
    //             hovertemplate:'<extra></extra>',
    //             line:{color:'black',dash:'dashdot'}}
    // var clickMarkerRwyDuration = {x:[],y:[],
    //             type:'scatter',
    //             xaxis:'x',yaxis:'y2',
    //             mode:'lines',
    //             showlegend:false,
    //             hoverinfo:'skip',
    //             hovertemplate:'<extra></extra>',
    //             line:{color:'black',dash:'dashdot'}}
    

    var approachMarginThresholdArea_trace = {x:[0,3,3],y:[1000,1000,0],
                                type:'scatter',
                                xaxis:'x3',yaxis:'y3',
                                mode:'none',
                                fill: 'tozeroy',
                                fillcolor:'rgba(255,0,0,0.1)',
                                hoverinfo:'skip',
                                name:'Approach Margin Violation Area',
                                showlegend:false}    

    var surfaceTracks_trace = {type: "scattermapbox",
                                lat: aircraftTrackValues.lat,
                                lon: aircraftTrackValues.lon,
                                text: aircraftTrackValues.alt,
                                customdata:aircraftTrackValues.labelData,
                                marker: {color: "red", size: 10},
                                hovertemplate:'<extra></extra><b>Lat</b>:%{lat:.2f} <b>Lon</b>:%{lon:.2f} <b>Alt</b>:%{text:.0f}ft<br>'+
                                                    '<b>Time</b>: %{customdata[0]}<br>'+
                                                    '<b>Acid</b>: %{customdata[1]}',
                                hoverlabel:{bgcolor:'white'},
                                opacity:0.3,
                                showlegend:false}    
    return (
        <Layout>
        <PlotSectionDiv id="chartPlotDiv" flexRatio={5}>
            <PlotLoadingOverlay show={isChartLoading}/>
            <EpochDataBlock selectedEpoch={selectedEpoch} handleLatestEpochButton={handleLatestEpochButton}
                            lastUpdatedTime={lastUpdatedTime}/>
            <Plot  data={[
                  avgLateralSeparation_trace,
                  maxRwyDurationRange_trace,
                  separationDist_trace,
                  approachMarginThresholdArea_trace,
                  rwyDuration_trace,
                  acDataTableTrace,
                  { x:[selectedEpoch,selectedEpoch],
                    y:[0,Object.hasOwn(plotChartLayout.yaxis,'range')?plotChartLayout.yaxis.range[1]:1],
					type:'scatter',
					xaxis:'x',yaxis:'y',
					mode:'lines',
					showlegend:false,
					hoverinfo:'skip',
					hovertemplate:'<extra></extra>',
					line:{color:'black',dash:'dashdot'}},
			      { x:[selectedEpoch,selectedEpoch],
                    y:[0,Object.hasOwn(plotChartLayout.yaxis2,'range')?plotChartLayout.yaxis2.range[1]:1],
					type:'scatter',
					xaxis:'x',yaxis:'y2',
					mode:'lines',
					showlegend:false,
					hoverinfo:'skip',
					hovertemplate:'<extra></extra>',
					line:{color:'black',dash:'dashdot'}},
                //   { x:Object.keys(rwyArrivals[selectedPointIndex]),
                //     y:Object.values(rwyArrivals[selectedPointIndex]),
                //     type:'bar',
                //     xaxis:'x3',
                //     yaxis:'y3',
                //     width:0.6,
                //     name:'Arrival Counts',
                //     marker:{color:'indianred'},
                //     hovertemplate:'%{y}',
                //     showlegend:false}
                ]}
                layout= {plotChartLayout}
                config= {plotConfig}
                divId={'plotlyChartDiv'}
                style={{minWidth:'300px',height:'95%',position:'relative'}}
                useResizeHandler={true}
                onClick={handleClickOnChart}
                onDoubleClick={()=>{}}
              />
        </PlotSectionDiv>
        <PlotSectionDiv id="mapPlotDiv" key={revKey} flexRatio={3}>
            <PlotLoadingOverlay show={isMapLoading} label="Loading map…"/>
            <Plot data={[surfaceTracks_trace]}
                  layout= {plotMapLayout}
                  config= {{...plotConfig,scrollZoom:true}}
                  useResizeHandler={true}
                  divId={'plotlyMapDiv'}
                  style={{minWidth:'300px',height:'90%',position:'relative',borderWidth:'2px',color:'yellow',
                            borderSyle:'solid',
                            borderColor:'black'}}
                  onDoubleClick={handleDoubleClickOnMap}
            />
        </PlotSectionDiv>  
        </Layout>
    );
};

export default AirGroundInteractions


